export default function checkoutOrderDetailsCtrl($scope, $http, $rootScope, $compile, $timeout, bsLoadingOverlayService) {
    $scope.promoForm = {};
    $scope.promoForm.action = '';
    $scope.promoForm.response = '';
    $scope.stripe_token = '';
    /**
     * 
     * Card     //1
     * BANK     //2
     * COD      //3
     * 
     */

    $scope.payment_method = -1;

    $scope.initPayment = function () {
        // Create a Stripe client.
        var stripe = Stripe('pk_test_WCKXjuvFncHuWr1pjRb8Nd4x');

        // Create an instance of Elements.
        var elements = stripe.elements();

        // Custom styling can be passed to options when creating an Element.
        // (Note that this demo uses a wider set of styles than the guide below.)
        var style = {
            base: {
                color: '#32325d',
                lineHeight: '18px',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#aab7c4'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        };

        // Create an instance of the card Element.
        var card = elements.create('card', {
            hidePostalCode: true,
            style: {
                base: {
                    iconColor: '#666EE8',
                    color: '#31325F',
                    '::placeholder': {
                        color: '#CFD7E0',
                    },
                },
            }
        });

        // Add an instance of the card Element into the `card-element` <div>.
        card.mount('#card-element');

        // Handle real-time validation errors from the card Element.
        card.addEventListener('change', function (event) {
            var displayError = document.getElementById('card-errors');
            if (event.error) {
                displayError.textContent = event.error.message;
            } else {
                displayError.textContent = '';
            }
        });

        // Handle form submission.
        var form = document.getElementById('payment-form');
        form.addEventListener('submit', function (event) {
            event.preventDefault();

            bsLoadingOverlayService.start();

            stripe.createToken(card).then(function (result) {
                if (result.error) {
                    // Inform the user if there was an error.
                    var errorElement = document.getElementById('card-errors');
                    errorElement.textContent = result.error.message;
                    bsLoadingOverlayService.stop();
                } else {
                    // Send the token to your server.
                    $('#stripeToken').val(result.token.id);
                    form.submit();
                }

            });
        });
    }

    $scope.setPaymentMethod = function (pm, event) {
        $scope.payment_method = pm;
        event.preventDefault();
    }

    $scope.setShippingMethod = function (shipping) {

        $rootScope.showOverlay('container-wrap');
        $http({
            method: "POST",
            url: '/' + window.Laravel.code + '/shipping/methods/select',
            data: $rootScope.params(shipping), // pass in data as strings
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            } // set the headers so angular passing info as form data (not request payload)
        }).then(function success(response) {
            // $rootScope.hideOverlay('checkout-order-details');
            // window.location.reload();
            var data = response.data;
            if (data.status === false) {

            } else {
                window.location.reload();
            }
        }, function error(response) {
            var data = response.data;
            console.log("Error: ", data);
        });
    }

    $scope.showProceedPayment = function () {
        var show = false;
        var allowed = [1, 2, 3, 5];
        if (allowed.indexOf($scope.payment_method) > -1) {
            show = true;
        }
        return show;
    }

    $scope.stripeInitPayment = function (event) {
        window.Stripe.stripeVueComponent.error = null;
        $rootScope.showOverlay('container-wrap');
        
        $http({
                method: "GET",
                url: window.Stripe.createIntentRoute,
                data: {},
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                } // set the headers so angular passing info as form data (not request payload)
            })
            .then(function (response) {
                var _data = response.data;
                $scope.stripe_token = _data.clientSecret;
                $('#stripeToken').val(_data.clientSecret);
                return _data.clientSecret;
            })
            .then(function (clientSecret) {
                window.Stripe.stripeObject.confirmCardPayment(
                        clientSecret, {
                            payment_method: {
                                card: window.Stripe.stripeCardObject
                            }
                        }
                    ).then(function (result) {
                        if (result.error) {
                            // Display error.message in your UI.
                            console.log(result);
                            window.Stripe.stripeVueComponent.error = result.error.message;
                            $rootScope.hideOverlay('container-wrap');
                            $scope.stripe_token = '';
                            $('#stripeToken').val('');
                        } else {
                            // window.Stripe.$refs.checkoutForm.submit();
                            $('#finalize').trigger('click');
                        }
                    })
                    .catch(function (error) {
                        console.log("error:", error.response.data);
                    });

            })
            .catch(function (error) {
                // console.log(error);
                var error_message = '';
                
                try {
                    if ( 
                        typeof error !=='undefined' && 
                        typeof error.response !=='undefined' && 
                        typeof error.response.data !== 'undefined' &&
                        typeof error.response.data.message !== 'undefined'
                    ) {
                        error_message = error.response.data.message;
                    }else if(
                        typeof error !== 'undefined' &&
                        typeof error.data !== 'undefined' &&
                        typeof error.data.message !== 'undefined'
                    ){
                        error_message = error.data.message;
                    }else{
                        error_message = '';
                    }
                } catch (error) {
                    error_message = 'THERE WAS AN ERROR. PLEASE TRY AGAIN LATER...';
                }

                if(
                    typeof error !== 'undefined' &&
                    typeof error.data !== 'undefined' &&
                    typeof error.data.reload !== 'undefined' && 
                    error.data.reload
                ){
                    window.location.reload();
                }else{
                    $rootScope.hideOverlay('container-wrap');
                }

                window.Stripe.stripeVueComponent.error = error_message;
                
            });
    }

    $scope.proceedWithPayment = function (event) {

        if (!$scope.finalazePaymentForm.validate()) {
            event.preventDefault();
            return false;
        }

        switch ($scope.payment_method) {
            case 5: {
                if($scope.stripe_token==''){
                    event.preventDefault();
                    $scope.stripeInitPayment(event);
                    return false;
                }else{
                    // $rootScope.showOverlay('container-wrap');
                }
                break;
            }
            default: {
                $rootScope.showOverlay('container-wrap');
                break;
            }
        }
    }

    $scope.showOverlay = function () {
        bsLoadingOverlayService.start();
    }

    $scope.validationOptions = {
        rules: {
            email: {
                required: true,
                email: true
            },
            password: {
                required: true
            },
            password2: {
                required: true,
                equalTo: "#new-user-pass"
            }
        },
        messages: {
            email: {
                required: "We need your email address to contact you",
                email: "Your email address must be in the format of name@domain.com"
            }
        },
        ignore: [],
        errorPlacement: function (error, element) {
            if ($(element).is(":hidden")) {
                var hidELement = $(element).parent().parent();
                error.insertAfter(hidELement);
            } else {
                var element = $(element);
                error.insertAfter(element);
            }
        },
        highlight: function (element, errorClass, validClass) {
            if ($(element).is(":hidden")) {
                $(element)
                    .parent()
                    .addClass(errorClass)
                    .removeClass(validClass);
            } else {
                $(element)
                    .addClass(errorClass)
                    .removeClass(validClass);
            }
        },
        unhighlight: function (element, errorClass, validClass) {
            if ($(element).is(":hidden")) {
                $(element)
                    .parent()
                    .removeClass(errorClass)
                    .addClass(validClass);
            } else {
                $(element)
                    .removeClass(errorClass)
                    .addClass(validClass);
            }
        }
    };

    /**
     * ACCOUNT DETAILS
     */
    $rootScope.applyPromo = function (regform, route) {

        var isvalid = $scope.promoFormName.validate();

        if (isvalid) {
            $rootScope.showOverlay('checkout-order-details');
            $http({
                method: "POST",
                url: route,
                data: $rootScope.params($scope.promoForm), // pass in data as strings
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                } // set the headers so angular passing info as form data (not request payload)
            }).then(function success(response) {
                var data = response.data;

                if (data.status === false) {
                    $scope.promoForm.response = data.msg;
                } else {
                    window.location.reload();
                }
            }, function error(response) {
                var data = response.data;
                console.log("VOUCHER Error: ", data);
            });
        }

    };

    // $scope.initPayment();

    $scope.signupToNewsletter = function () {


        bsLoadingOverlayService.start();
        // $http({
        //     method: "GET",
        //     url: "/actions.php?action=subscribetonewsletter&email=" + $scope.email,
        //     headers: {
        //         "Content-Type": "application/x-www-form-urlencoded"
        //     } // set the headers so angular passing info as form data (not request payload)
        // }).then(function success(response) {
        //     var data = response.data;
        //     bsLoadingOverlayService.stop();
        //     $scope.newsletterFormSuccess = true;
        //     $scope.newsletterFormMsg = data.message;

        //     $timeout(function () {
        //         $scope.newsletterFormSuccess = false;
        //     }, 3000);


        // }, function error() {
        //     bsLoadingOverlayService.stop();
        // });
    }

    $scope.cartContainsSpecialDesign = function () {
        var hasIt = false;
        $rootScope.session.items.forEach(element => {
            if (element.color != false) {
                hasIt = true;
            }
        });
        return hasIt;
    }

    $scope.removeProductFromCart = function(action, oiid, val){
        $http({
            method: "GET",
            url: "/en/cart/"+action+"/"+oiid+"/"+val,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            dataType: "json"
        }).then(function success(response) {
            var data = response.data;
            if (data.total.items == 0 || window.location.pathname == '/en/checkout/delivery-details') {
                window.location.reload();
                return false;
            }
            if(window.location.pathname == '/en/checkout/order-details'){
                window.location.href = '/en/checkout/delivery-details';
            }
        }, function error(errorData) {
            var error = errorData;
            console.log('Error managequantity:', error);
        });
    }

    $scope.consentPriceChange = function(oiid){

        $http({
            method: "GET",
            url: "/en/cart/consent/"+oiid,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            dataType: "json"
        }).then(function success(response) {
            var data = response.data;
            if (data.total.items == 0 || window.location.pathname == '/en/checkout/delivery-details') {
                window.location.reload();
                return false;
            }
            if(window.location.pathname == '/en/checkout/order-details'){
                window.location.href = '/en/checkout/delivery-details';
            }
        }, function error(errorData) {
            var error = errorData;
            console.log('Error managequantity:', error);
        });
    }
}

checkoutOrderDetailsCtrl.$inject = ['$scope', '$http', '$rootScope'];